export enum FILTERS_ERROR {
  TYPE = "FILTER_ERROR",
  TITLE = "Too many filters applied",
  MESSAGE = "Too many filters applied! Try removing some?",
}

export enum NO_DATA_FOUND {
  TYPE = "NO_DATA_FOUND",
  TITLE = "No buses found",
  MESSAGE = "Please choose a different route or date for your journey.",
}

export enum BOOKING_STATUS {
  CONFIRMED = "Confirmed",
  CANCELLED = "Cancelled",
  PAYMENT_FAILED = "Payment Failed",
  BOOKING_FAILED = "Booking Failed",
  REFUNDED = "Refunded",
  PREPAYMENT_INITIALIZED = "Prepayment Initialized",
  RECONFIRMATION_PENDING = "Reconfirmation Pending",
}

export enum TRIP_STATUS {
  UPCOMING = "UPCOMING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
}

export enum NO_RATINGS_AND_REVIEWS_DATA {
  TYPE = "NO_RATINGS_AND_REVIEWS_DATA",
  TITLE = "No ratings yet",
}

export enum API_FAILED {
  TYPE = "API_FAILED",
  TITLE = "Oops",
  MESSAGE = "Something went wrong",
}

export enum INCORRECT_URL {
  TYPE = "API_FAILED",
  TITLE = "Incorrect url",
  MESSAGE = "Please check your url",
}

export enum INCORRECT_DEPART_DATE {
  TYPE = "INCORRECT_DEPART_DATE",
  TITLE = "Incorrect date",
  MESSAGE = "Please check the departure date",
}

export enum SC_SERVER_ERROR {
  TYPE = "SC_SERVER_ERROR",
  TITLE = "Unable to load details",
  MESSAGE = "We are currently not able to load the details of this bus.",
  BTN_TITLE = "Back to bus listings",
}

export const couponData = [
  {
    couponText:
      "Flat 15% on all buses with SBI banks credit cards. Use coupon SBICC, Flat 15% on all buses with SBI banks credit cards. Use coupon SBICC",
  },
  {
    couponText:
      "Flat 15% on all buses with ICICI banks credit cards. Use coupon ICICC",
  },
  {
    couponText:
      "Flat 25% on all buses with HDFC banks credit cards. Use coupon HDFCC",
  },
  {
    couponText:
      "Flat 30% on all buses with AXIS banks credit cards. Use coupon AXICC",
  },
];

export const Rs = "₹";
